import { render, staticRenderFns } from "./ItemFilterOpenMyFilter.vue?vue&type=template&id=37902627&scoped=true"
import script from "./ItemFilterOpenMyFilter.vue?vue&type=script&lang=js"
export * from "./ItemFilterOpenMyFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37902627",
  null
  
)

export default component.exports